var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82839 11.6667C8.79699 11.8689 8.76872 12.0323 8.74426 12.1628C8.59172 12.9771 7.43699 13.4671 6.81886 13.9042C6.45091 14.1644 6.0044 13.8547 5.95672 13.4519C5.86582 12.6841 5.69461 11.1243 5.50772 8.84092C5.49093 8.63592 5.39144 8.45072 5.23984 8.33739C3.58088 7.09705 2.39863 5.73277 1.7531 4.96578C1.55327 4.72835 1.48779 4.5546 1.44842 4.24853C1.31361 3.20053 1.24621 2.67653 1.5535 2.33827C1.8608 2 2.40423 2 3.49109 2H11.1787C12.2655 2 12.8089 2 13.1162 2.33827C13.2653 2.50231 13.3261 2.71003 13.334 3",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9085 4.95939L14.3714 5.42097C14.763 5.81149 14.763 6.44466 14.3714 6.83519L11.9464 9.29899C11.7557 9.48919 11.5117 9.61746 11.2465 9.66679L9.74352 9.99219C9.50619 10.0436 9.29492 9.83346 9.34572 9.59666L9.66565 8.10646C9.71519 7.84199 9.84379 7.59866 10.0345 7.40846L12.4904 4.95939C12.882 4.56887 13.5169 4.56887 13.9085 4.95939Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterEdit);
export default __webpack_public_path__ + "static/media/filter-edit.3f6baa6b8386a5286240b9e36ad3d3b2.svg";
export { ForwardRef as ReactComponent };